// extracted by mini-css-extract-plugin
export var container = "_41-0";
export var icon = "_41-1";
export var text = "_41-2";